import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";
import LoginView from "../views/LoginView.vue";
import ScheduleView from "../views/ScheduleView.vue";
import LogoutView from "../views/LogoutView.vue";
import JobCallsView from "../views/JobCallsView.vue";
import ChangePassword from "../views/ChangePassword.vue"
import Profile from "../views/Profile.vue"
import RegisterView from "../views/RegisterView.vue"
import ValidationView from "../views/ValidationView.vue"
import UploadDocuments from "../views/UploadDocuments.vue"
import FaceVerification from "../views/FaceVerification.vue"


const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
    //props: { baseUrl: "https://localhost:44325/" },
    //props: { baseUrl: "https://emergingsols2.somee.com/" },
  },
  {
    path: "/logout",
    name: "logout",
    component: LogoutView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
    //props: { baseUrl: "https://localhost:44325/" },
    //props: { baseUrl: "https://emergingsols2.somee.com/" },

  },
  {
    path: "/schedule",
    name: "schedule",
    component: ScheduleView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
    //props: { baseUrl: "https://localhost:44325/" },
    //props: { baseUrl: "https://emergingsols2.somee.com/" },
  },
  {
    path: "/jobcalls",
    name: "jobcalls",
    component: JobCallsView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
    //props: { baseUrl: "https://localhost:44325/" },
    //props: { baseUrl: "https://emergingsols2.somee.com/" },
  },
  {
    path:"/changepassword",
    name:"changepassword",
    component: ChangePassword,
    props:{baseUrl: localStorage.getItem("baseUrl"), userId:11},
    //props:{baseUrl: "https://localhost:44325/", userId:11},
    //props:{baseUrl: "https://emergingsols2.somee.com/", userId:0},
  },
  {
    path:"/profile",
    name:"profile",
    component:Profile,
    props:{baseUrl: localStorage.getItem("baseUrl")},
    //props:{baseUrl: "https://localhost:44325/"},
    //props:{baseUrl: "https://emergingsols2.somee.com/"},

  },
  {
    path:"/documents",
    name:"documents",
    component:UploadDocuments,
    props:{baseUrl: localStorage.getItem("baseUrl")},
  },
  {
    path:"/register",
    name:"register",
    component:RegisterView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
    //props:{baseUrl: "https://localhost:44325/"},
    //props:{baseUrl: "https://emergingsols2.somee.com/"},  
  },
  {
    path:"/validationview",
    name:"validationview",
    component:ValidationView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
    //props:{baseUrl: "https://localhost:44325/"},
    //props:{baseUrl: "https://emergingsols2.somee.com/"},  
  },
  {
    path:"/faceverification",
    name:"faceverification",
    component:FaceVerification,
    props:{baseUrl: localStorage.getItem("baseUrl")},
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
